<template>
  <div class="sex__item">
    <ul class="age__header">
      <li class="age__title">
        {{title}}
      </li>
      <li class="age__tools">
        <el-button type="text" class="age__tools-button" :disabled="saveChart" @click="onSave('age')">
          <i class="material-icons color_grey">save</i>
        </el-button>
        <el-button type="text" class="age__tools-button" v-if="!isEdit" @click="editChart(name)">
          <i class="material-icons color_grey">edit</i>
        </el-button>
      </li>
    </ul>

    <el-card shadow="hover" class="sex__card" v-loading="pending">
      <in-age-header :chart-name="name" />
      <in-age-body
        :data="data"
        :chart-name="name"
        :save-chart="saveChart"
        :title="title"
        @onSavedChart="handleSaved"
        @onSaveChart="handleSave"
      />
    </el-card>
  </div>
</template>


<script>
  //actions
  import { GET_IN_AGE, SET_AUDIT_PENDING } from "../../../../../../../store/actions/audit";

  // components
  import InAgeHeader from "./header/InAgeHeader";
  import InAgeBody from "./body/InAgeBody";

  export default {
    name: "Age",
    data() {
      return {
        name: "Age",
        title: this.$t('feed.audit.age.title'),
        saveChart: false
      };
    },
    methods: {
      editChart() {
        this.$router.push({
          name: 'feedAuditEdit',
          params: {
            chart: "Age"
          }
        });
      },
      onSave() {
        this.saveChart = true;
      },
      handleSaved(chart) {
        this.$store.commit(SET_AUDIT_PENDING, {chart, pending: false});
        this.saveChart = false;
      },
      handleSave(chart) {
        this.$store.commit(SET_AUDIT_PENDING, {chart, pending: true});
      }
    },
    computed: {
      isEdit() {
        return this.$route.meta.singlePage;
      },
      data() {
        return this.$store.getters.auditData(this.name);
      },
      pending() {
        return this.$store.getters.auditPending(this.name);
      },
    },
    mounted() {
      const params = {
        chart: this.name,
        thread: this.$route.params.threadId
      };

      this.$store.dispatch(GET_IN_AGE, params);
    },
    components: {
      InAgeHeader,
      InAgeBody
    }
  }
</script>


<style>

  .sex__item {
    flex-basis: 50%;
    margin-right: 20px;
  }

  .sex__item:last-child {
    margin-right: 0;
  }

  .sex__card {
    margin-bottom: 20px;
  }

  .age__header {
    display: flex;
    justify-content: space-between;
    align-items: start;
    padding: 0;
    margin: 0;
    list-style: none;
  }

  .age__title {
    margin-bottom: 20px;
    font-family: "Roboto", "Arial", sans-serif;
    font-style: normal;
    font-weight: normal;
    font-size: 16px;
    line-height: 19px;

    color: #5E6D82;
  }

  .age__tools .material-icons {
    font-size: 16px;
  }

  .age__tools {
    margin-top: 4px;
    margin-right: 15px;
  }

  .age__tools-button {
    padding: 0;
    color: #5e6d82;
  }

  .age__tools-button:hover {
    color: #B3BCCC;
    font-size: 12px;
  }

</style>

